import i18n from '../i18n/i18n'
import React from 'react';
export const useTranslation = (ns?: string) => {
  const t = React.useCallback((key, options?) => i18n.t(key, {ns, ...options}), [ns, i18n]);
  return {t, i18n};
};

